import { reducer } from "./reducers";
import { FeatureConfiguration } from "app/featureConfig";

export default function (config: FeatureConfiguration) {
    config.reducers.search = reducer;
}

export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
export const MEANDU_ID = /^(sms\||email\|)?[0-9a-fA-F]{24}$/i;
